





















































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Watch } from 'vue-property-decorator';
import { BoxIcon, CalendarIcon, SearchIcon, UserIcon } from 'vue-feather-icons';

import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';
import { DateFilter, EmployeeFilter, IProduct, IUser } from 'admiral-core';
import 'dayjs/locale/de';
import dayjs from 'dayjs';
import Multiselect from 'vue-multiselect';
import { PreferencesAction } from '@/store/PreferencesModule';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';

dayjs.locale('de');

@Component({
  components: { CalendarIcon, vSelect, UserIcon, BoxIcon, SearchIcon, Multiselect },
})
export default class EmployeesFilter extends mixins(FilterMixin) {
  filter: EmployeeFilter = {
    dateFilter: DateFilter.ALL,
    products: [],
    users: [],
  };

  allUsers: IUser[] = [];
  allProducts: IProduct[] = [];

  async mounted() {
    try {
      // this.allUsers = [
      //   {
      //     id: '-',
      //     firstname: 'Alle',
      //     lastname: 'Mitarbeiter',
      //   },
      // ];
      // this.allUsers = this.allUsers.concat((await AdmiralApi.getUsers()).data);
      // this.allProducts = (await AdmiralApi.getProducts()).data;

      this.filter = await this.$store.getters['PreferencesModule/getEmployeeFilter'];
    } catch (e) {
      console.log(e);
    }
  }

  @Watch('filter.user')
  private onSelectedUsersChange() {
    this.updateFilter();
  }

  @Watch('filter.dateFilter')
  private onSelectedDateChange() {
    this.updateFilter();
  }

  @Watch('filter.products')
  private onSelectedProductsChange() {
    this.updateFilter();
  }

  get selectableProducts() {
    return this.allProducts.map((product: IProduct) => {
      return { name: product.name, id: product.id };
    });
  }

  async updateFilter() {
    await this.$store.dispatch(
      `PreferencesModule/${PreferencesAction.setEmployeeFilter}`,
      this.filter,
    );
    this.$root.$emit('user-product-rate-filter', this.filter);
  }

  get selectableEmployees() {
    return this.allUsers.map((user: IUser) => {
      return { name: `${user.lastname}, ${user.firstname}`, id: user.id };
    });
  }
}
